import ServiceLargeCard from "../../../components/ui/Cards/ServiceLargeCard";

const UnregisteredCompanyUser = () => {
  return (
    <div>
      <div className=" mb-12">
        <h1 className="text-lg lg:text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
          Welcome to Company Registration
        </h1>
        <p className="text-sm lg:text-lg text-gray-600">
          Choose your path to get started with your business journey
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ServiceLargeCard
          title="Already have a company?"
          sub_title="Enter company details"
          button_title="Submit or Join Company"
          link="/dashboard/company-update"
          more_info="Step 1 of 3 in company registration process"
        />
        <ServiceLargeCard
          title="Start a company?"
          sub_title="Incorporate now"
          button_title="Continue"
          link="/dashboard/services"
        />
      </div>
    </div>
  );
};

export default UnregisteredCompanyUser;
